import { useState } from "react";
import ModalShell from "./ModalShell";
import { rosterTheme as t } from "./rosterTheme";

export default function AdminOverrideModal({ open, onClose, roster, onConfirm }) {
  const [reason, setReason] = useState("");
  const [action, setAction] = useState("reopen");
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!reason.trim()) return;
    setSaving(true);
    try {
      await onConfirm({ action, override_reason: reason.trim() });
      onClose();
      setReason("");
    } finally {
      setSaving(false);
    }
  };

  return (
    <ModalShell open={open} title="Admin override" onClose={onClose}>
      <p className={`${t.cardSub} mb-4`}>
        Roster <strong>{roster?.name}</strong> is <strong>{roster?.status}</strong>.
        Administrative action requires a documented reason.
      </p>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className={t.label}>Action</label>
          <select className={t.select}
            value={action}
            onChange={(e) => setAction(e.target.value)}
          >
            <option value="reopen">Reopen for editing (→ draft)</option>
            <option value="force_publish">Force publish</option>
          </select>
        </div>
        <div>
          <label className={t.label}>Override reason *</label>
          <textarea className={t.input}
            rows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Emergency shift change, audit reference…"
            required
          />
        </div>
        <div className="flex justify-end gap-2">
          <button type="button" onClick={onClose} className={t.btnSecondary}>
            Cancel
          </button>
          <button
            type="submit"
            disabled={saving || !reason.trim()}
            className="px-4 py-2 text-sm font-medium bg-amber-600 text-white rounded-lg hover:bg-amber-700 disabled:opacity-50"
          >
            Confirm override
          </button>
        </div>
      </form>
    </ModalShell>
  );
}
